import { useT } from "@/i18n";

/**
 * The combined list title shown wherever tours and leagues share one page
 * (sidebar link, list heading, create-page breadcrumb): "Circuits & Leagues".
 * The two nouns are interpolated from the existing naming-aware list-title keys
 * so the per-locale wording stays in a single source of truth. Note the `.tour`
 * leaf is only the key name — its text is "Circuit" in every English locale.
 */
export const useLeaguesListTitle = () => {
  const t = useT();

  return t("league.pages.list.combinedTitle", {
    tour: t("league.pages.list.title.tour"),
    league: t("league.pages.list.title.league"),
  });
};
